// extracted by mini-css-extract-plugin
export default {"ErrorFallback":"ErrorFallback_ErrorFallback__56V5s"};